<script setup lang="ts">

import { Check, X } from 'lucide-vue-next';

import DashboardLayout from '~/layouts/DashboardLayout.vue';
import useAuth from '~/store/auth/useAuth';
import date from '~/utils/date';

const {
  data: user,
  isFetching: isFetchingUser,
  isLoading: isLoadingUser,
} = useAuth();
</script>

<template>
  <DashboardLayout title="Perfil" description="Perfil do usuário" :loading="isLoadingUser || isFetchingUser">
    <div class="row gx-2 gy-2">

      <!-- keycloack -->
      <div class="col">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Detalhes do Keycloack</h3>
          </div>
          <div class="card-body">
            <div class="datagrid">
              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">ID</div>
                <div class="datagrid-content"><b>#{{ user?.keycloack.sub }}</b></div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Nome</div>
                <div class="datagrid-content">{{ user?.keycloack.name }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Nome de usuário</div>
                <div class="datagrid-content">{{ user?.keycloack.preferred_username }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Email</div>
                <div class="datagrid-content">{{ user?.keycloack.email }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Email Verificado</div>
                <div class="datagrid-content">
                  <div v-if="user?.keycloack.email_verified">
                    <Check class="icon icon-2 text-green" /> Sim
                  </div>
                  <div v-else>
                    <X class="icon icon-2 text-red" /> Não
                  </div>
                </div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Perfil</div>
                <div class="datagrid-content">{{ user?.keycloack.profile ?? '-' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- person -->
      <div class="col">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Detalhes da Person </h3>
          </div>
          <div class="card-body">
            <div class="datagrid">
              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">ID</div>
                <div class="datagrid-content"><b>#{{ user?.person.id }}</b></div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">CPF</div>
                <div class="datagrid-content">{{ user?.person.document ?? '-' }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Nome</div>
                <div class="datagrid-content">{{ user?.person.fullname }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Nome de usuário</div>
                <div class="datagrid-content">{{ user?.person.username }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Email</div>
                <div class="datagrid-content">{{ user?.person.contact.email }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Telefone</div>
                <div class="datagrid-content">{{ user?.person.contact.mobile }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Data de nascimento</div>
                <div class="datagrid-content">
                  {{ user?.person.birthdate ? date(user?.person.birthdate).format("LL") : '-' }}
                </div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Ativo</div>
                <div class="datagrid-content">
                  <div v-if="user?.person.active">
                    <Check class="icon icon-2 text-green" /> Sim
                  </div>
                  <div v-else>
                    <X class="icon icon-2 text-red" /> Não
                  </div>
                </div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Perfil</div>
                <div class="datagrid-content">{{ user?.person.profile }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Criado em</div>
                <div class="datagrid-content">{{ date(user?.person.created_at).format("LLLL") }}</div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>
